import React from 'react';
import './SoundWave.css';

const SoundWave = ({ isActive = false, variant = 'default', size = 'medium' }) => {
  const className = `sound-wave ${isActive ? 'active' : ''} ${variant} ${size}`;
  
  return (
    <div className={className}>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
    </div>
  );
};

export default SoundWave;
